import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"
Chart.register(...registerables)

export default class extends Controller {
  static targets = ["canvas"]
  static values = { points: Array }
  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.pointsValue.map(p => p.date.split("-").reverse().join("/")),
        datasets: [{ label: "Valor contratado", data: this.pointsValue.map(p => p.cents / 100), backgroundColor: "#047857", borderRadius: 3 }]
      },
      options: {
        responsive: true, maintainAspectRatio: false, animation: false,
        plugins: { legend: { display: false }, tooltip: { callbacks: { label: context => context.parsed.y.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) } } },
        scales: { y: { beginAtZero: true, title: { display: true, text: "Valor contratado (R$)" } }, x: { ticks: { maxTicksLimit: 12, maxRotation: 0 } } }
      }
    })
  }
  disconnect() { this.chart?.destroy() }
}
